import { HomeOutlined } from '@ant-design/icons'
import { Breadcrumb as AntdBreadcrumb } from 'antd'
import type { MouseEvent } from 'react'

/**
 * `onNavigate` turns item links into in-app navigation the caller controls,
 * e.g. to confirm before leaving a form with unsaved changes.
 */
export default function Breadcrumb({ additionalItems, onNavigate }: any) {
  const breadcrumbItems = [
    {
      href: '/',
      title: (
        <span style={{ display: 'flex', gap: 10 }}>
          <HomeOutlined /> Home
        </span>
      ),
    },
    ...additionalItems,
  ]

  const items = onNavigate
    ? breadcrumbItems.map((item) =>
        item.href
          ? {
              ...item,
              onClick: (e: MouseEvent) => {
                e.preventDefault()
                onNavigate(item.href)
              },
            }
          : item
      )
    : breadcrumbItems

  return <AntdBreadcrumb items={items} style={{ marginBottom: '20px' }} />
}
